<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="$store.state.user.roleType !== 2" >
            <label >门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
          </div>
          <div class="queryItem">
            <label >销售单号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.orderNo"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单状态:</label>
            <lk-select v-model='query.status' class="item" clearable  >
              <lk-option v-for="(item, index) in orderStatus" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >创建时间:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.duration"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>预约随访时间:</label>
            <timeStampDatePicker
              placeholder="请选择"
              v-model="query.time"
              class="item"
              type="daterange"
            ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.patientName"></lk-input>
          </div>
          <div class="queryItem">
            <label>随访电话:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.phone"></lk-input>
          </div>
          <div class="queryItem">
            <label >随访药品:</label>
            <lk-input placeholder='请输入药品通用名' class="item" clearable v-model.trim="query.interviewDrugs"></lk-input>
          </div>
          <div class="queryItem">
            <label>药学服务状态:</label>
            <lk-select v-model='query.isFollowUpStatus' class="item" clearable  >
              <lk-option v-for="(item, index) in sharedData.statusList" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>订单类型:</label>
            <lk-select v-model='query.type' class="item" clearable  >
              <lk-option v-for="(item, index) in sharedData.orderType" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>订单来源:</label>
            <lk-select
              v-model='query.orderSourceType'
              class="item"
              clearable
              @on-change='(val)=>{val===0&&(query.epCreatorType=null)}'>
              <lk-option
                v-for="(item,index) in sourceTypeList"
                :key="index"
                :value='item.id'
              >
                {{item.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>

      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData' />
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import sale from '../../services/sale';
import system from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import sharedData from '../../libs/sharedDara';

export default {
  name: 'pharmaceuticalCareList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    ownRouter() {
      return this.$store.state.app.permissionList;
    },
    baseInfo() {
      return this.$store.state;
    },
    ifShowDosageform() {
      return this.$store.state.storeInfo.id === 55 ? true : false; //55赣州门店的id，门店的特殊需求要在规格后加上剂型字段
    }
  },
  watch: {
  },
  data() {
    return {
      sourceTypeList: [],
      orderStatus: [ //订单状态
        {
          id: 1,
          name: '待完成'
        },
        {
          id: 2,
          name: '已完成'
        },
      ],
      sharedData: {},
      ifShunfeng: false,
      expressBrother: {
        exName: '',
        exPhone: '',
        exDate: '',
        acceptTime: '',
      },
      update: false,
      Received: 0,
      totalReceive: 0,
      paymentList: [],
      disablePage: false,
      payment: 0,
      paymentParams: {

      },
      query: {
        orderNo: '',
        type: null, //订单类型
        status: null, //订单状态
        storeIds: [],
      },
      params: {
        orderNo: '',
        startTime: null,
        endTime: null,
        receiptStartTime: null,
        receiptEndTime: null,
        storeIds: [],
        phaFlag: 1,
      },
      columns: [
        { title: '序号', key: 'number', minWidth: 60 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '销售单号', key: 'orderNo', minWidth: 170 },
        { title: '订单状态', key: 'statusName', minWidth: 100 },
        { title: '创建时间', key: 'createTime', minWidth: 130 },
        { title: '患者姓名', key: 'patientName', minWidth: 116 },
        { title: '随访电话', key: 'phone', minWidth: 116 },
        { title: '随访药品', key: 'interviewDrugs', minWidth: 116 },
        { title: '药学服务状态', key: 'isFollowUpStatusStr', minWidth: 116 },
        { title: '随访预约时间', key: 'followUpTimeStr', minWidth: 130 },
        { title: '订单类型', key: 'orderTypeString', minWidth: 90 },
        { title: '订单来源', key: 'epSourceTypeName', minWidth: 116 },
        { title: '营业员', key: 'createUserName', minWidth: 100 },
        { title: '订单金额', key: 'totalAmountDisplay', minWidth: 116 },
        { title: '折扣金额', key: 'discount', minWidth: 116 },
        {
          title: '操作',
          width: 116,
          fixed: 'right',
          render: (h, params) => h('div', [
            // rightFlag  1-不可编辑、2-可编辑
            this.handlePermission('pcOrderPharmaceuticalCare') && params.row.rightFlag == 2 && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'pcOrderPharmaceuticalCare', params: { id: params.row.id } });
                  // this.$router.push({ name: 'pharmaceuticalCare', params: { id: params.row.id, taskId: params.row.taskId ? params.row.taskId : null } });
                },
              },
            }, '药学服务'),
            this.handlePermission('pcOrderPharmaceuticalCareCheck') && params.row.rightFlag == 1 && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'pcOrderPharmaceuticalCareCheck', params: { id: params.row.id, taskId: params.row.taskId ? params.row.taskId : null } });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      paidList: [],
      tableData: [],
      lastPay: {
        paymentMedicare: null, // 医保收款

        paymentCash: null, // 现金收款

        paymentWechat: null, // 微信收款

        paymentAlipay: null, // 支付宝收款

        paymentUnionpay: null, // 银联卡收款

        paymentPrepay: null, // 预收款
      },
      status: ['', '待完成', '已完成', '取消中', '已取消'],
      typeList: ['', '店销', '配送'],
      paymentArr: ['已收款', '部分收款', '未收款'],// 收款状态列表
      storeList: [],
      tempId: '',
    };
  },
  methods: {
    transferDate(val) {
      var d = new Date(val);    // 根据时间戳生成的时间对象
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var minute = d.getMinutes();
      var second = d.getSeconds();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (second < 10) {
        second = '0' + second;
      }
      let html = year + '-' + month + '-' + day + '  ' + hour + ':' + minute + ':' + second;
      return html;
    },

    handleChange() {
      let total = 0;
      this.paymentList.forEach((item) => {
        total += item.amount;
      });
      this.totalReceive = total;
    },
    // TODO：重置
    clear() {
      this.query = {
        orderNo: '',
        type: null, //订单类型
        status: null, //订单状态
        storeIds: [],
        time: [],
      };
    },
    getStoreList() {
      system.getBelongStores()
        .then((res) => {
          if (res.data.status === 200) {
            this.storeList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
    },
    handlerUpSuccess() {
      this.handleSearch();
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.query.duration && this.query.duration.length) {
        this.params.startTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
      }
      this.params.phaFlag = 1;
      sale
        .listReport(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            // console.log(res.data.data);
            this.tableData = [];
            // console.log(res.data.data.count);
            this.count = res.data.data.count;
            let number = 1;
            res.data.data.list.forEach((item) => {
              const result = {};

              utils.exchangeTable(item.saleOrder, result);
              // console.log(item);
              result.insurance = item.insurance;
              result.taskId = item.taskId || '';
              result.received = item.saleExpress && item.saleExpress.received;
              result.expressId = item.saleExpress && item.saleExpress.id;
              result.SFImage = (item.saleExpress && item.saleExpress.sfimage) || '';
              result.exName = (item.saleExpress && item.saleExpress.sfcourier) || '';
              result.exPhone = (item.saleExpress && item.saleExpress.sfcourierPhone) || '';
              result.exDate = (item.saleExpress && item.saleExpress.modifiedTime) || '';
              result.insuranceRefund = item.insuranceRefund;
              result.pharmaceuticalStatus = item.pharmaceuticalStatus;
              result._disabled = !result.ableToCreateProceeds;
              result.number = number++;
              result.createTime = utils.exchangeTimeToSecond(result.createTime);
              result.payTime = result.payTime == null ? '' : utils.exchangeTimeToSecond(result.payTime);
              result.confirmReceiptTime = result.confirmReceiptTime == null ? '' : utils.exchangeTimeToSecond(result.confirmReceiptTime);
              result.orderType = item.orderType;
              result.orderTypeString = this.typeList[item.orderType];
              // result.statusName = this.status[result.status];
              result.loading = false;
              result.totalGoodsNum = item.saleOrder.totalGoodsNum;
              result.totalAmount = item.saleOrder.totalAmount;
              result.realProceedsAmount = item.realProceedsAmount;
              result.ableToCancel = item.saleOrder.ableToCancel;
              result.saleExpress = item.saleExpress;
              result.realCashProceeds = item.realCashProceeds && item.realCashProceeds.amount;
              result.notOrigin = !result.epId;
              result.saleOrderProceedsList = [];
              result.receiptStatus = item.saleExpress && item.saleExpress.receiptStatus;
              result.code = item.saleExpress && item.saleExpress.code;
              result.acceptTime = item.saleExpress && item.saleExpress.acceptTime;
              result.patientName = item.saleOrder.patientName;
              result.phone = item.saleOrder.phone;
              result.isFollowUpStatusStr = item.isFollowUpStatusStr;
              result.rightFlag = item.rightFlag || '';
              result.interviewDrugs = item.interviewDrugs;
              result.followUpTimeStr = item.followUpTimeStr;
              if (item.saleOrderProceedsList) {
                result.saleOrderProceedsList = item.saleOrderProceedsList;
                result.saleOrderProceedsList = utils.deepClone(item.saleOrderProceedsList);

                item.saleOrderProceedsList.forEach((el) => {
                  result[`proceedsTypeId${el.proceedsTypeId}`] = el.amount;
                });
              }

              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },

    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.duration && params.duration.length) {
        params.startTime = params.duration[0];
        params.endTime = params.duration[1];
      }
      if (params.durationReceive && params.durationReceive.length) {
        params.receiptStartTime = params.durationReceive[0];
        params.receiptEndTime = params.durationReceive[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.startTime = utils.exchangeDate(params.startTime);
      // params.endTime = utils.exchangeDate(params.endTime);
      sale.downloadReport(params).then((res) => {
        console.log(res);

        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPaymentList() {
      // console.log(12312312);
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList().then((res) => {
          if (res.data.status === 200) {
            this.paymentList = res.data.data.list;
            this.paymentList.forEach((item) => {
              item.amount = null;
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getListSourceType() {
      return new Promise((resolve) => {
        sale.getListSourceType().then((res) => {
          if (res.data.status === 200) {
            this.sourceTypeList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
  created() {
    this.sharedData = sharedData;
  },
  mounted() {
    if (this.$store.state.user.roleType === 2) {
      for (let i = 0; i < this.columns.length; i += 1) {
        if (this.columns[i].key === 'storeName') {
          this.columns.splice(i, 1);
          i -= 1;
        }
      }
    }
    this.getListSourceType().then(() => {
      this.getPaymentList().then(() => {
        Object.assign(this.query, {
          patientName: this.$route.query.patientName || '',
          phone: this.$route.query.phone || '',
          orderNo: this.$route.query.orderNo || '',
        });
        this.handleSearch(true);
      });
    });
  },
};
</script>
<style lang="less" scoped>

  .btns{
    margin-bottom: 12px
  }
  .totalPay{
    font-size: 16px;
    color: #1890FF;
  }

  .saleBill {
    // width: 143vw;
  }
  .warnInfo {
    color: red;
    margin-left: 90px;
  }
  // .blockDisplay{
  //   width: 125%;
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: flex-end;
  // }
  // .firstRowDrug {
  // }
  // .table {
  //   width: 125%;
  // }
  // .sheetTitle {
  //   width: 125%;
  // }
  // .spLine {
  //   width: 125%;
  // }
  // .subTable {
  //   width: 125%;
  // }
  // .payData {
  //   width: 125%;
  // }
  // .infos {
  //   width:125%;
  // }
</style>
